import Fire from "@assets/loss-location-details/fire.webp";
import PersonalLiabilityIcon from "@assets/loss-location-details/liability.webp";
import Other from "@assets/loss-location-details/other.webp";
import Vandalism from "@assets/loss-location-details/vandalismTheft.webp";
import Water from "@assets/loss-location-details/water.webp";
import Weather from "@assets/loss-location-details/weather.webp";

import { LossType } from "@api/operations.generated";

export const lossTypes = [
  {
    image: Vandalism,
    label: "Theft/ Vandalism",
    value: LossType.TheftOrVandalism,
    tooltip:
      "Damages to the dwelling, other structures or personal property caused by the taking of or destruction of property from a party other than an insured person.",
  },
  {
    image: Weather,
    label: "Weather/ Property Damage",
    value: LossType.WeatherOrPropertyDamage,
    tooltip:
      "Damages to the dwelling, other structure or personal property caused by a natural weather event.",
  },
  {
    image: Fire,
    label: "Fire/Smoke Damage",
    value: LossType.FireOrSmokeDamage,
    tooltip:
      "Damages to the dwelling, other structure or personal property caused by fire, smoke or soot.",
  },
  {
    image: Water,
    label: "Water Damage",
    value: LossType.WaterDamage,
    tooltip:
      "Damages to the dwelling, other structure, or personal property from an interior water source.",
  },
  {
    image: PersonalLiabilityIcon,
    label: "Liability",
    value: LossType.Liability,
    tooltip:
      "Bodily injury or property damage sustained by other caused by an insured person.",
  },
  {
    image: Other,
    label: "Other",
    value: LossType.Other,
    tooltip:
      "All other types of loss to the dwelling, other structure or personal property.",
  },
];
